import { __generator } from "tslib";
import { all, call, takeEvery } from 'redux-saga/effects';
import { search } from './actions';
import { request } from '../../xhr';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var users = require('@wix/da-sample-data').users;
        return { users: users };
    }
}
function fetchFriendsForLetter(searchQuery, isChatContext) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: "/user/friendsforletter",
                    params: {
                        search: searchQuery,
                        letter: searchQuery[0],
                        page: 0,
                        is_chat: isChatContext || false,
                    },
                }, fakeResponse)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function handleSearch(_a) {
    var normalized, result, found;
    var _b = _a.payload, query = _b.query, callback = _b.callback, isChatContext = _b.isChatContext;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                normalized = query.trim().toLowerCase();
                if (normalized.length < 3) {
                    callback([]);
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(fetchFriendsForLetter, normalized, isChatContext)];
            case 1:
                result = _c.sent();
                if (result.error || !result.users || result.users.length === 0) {
                    return [2 /*return*/];
                }
                found = result.users
                    // include only those usernames that actually start with query
                    .filter(function (u) { return u.username.toLowerCase().startsWith(normalized); })
                    // unique
                    .filter(function (u, idx, self) { return self.findIndex(function (u2) { return u.userId === u2.userId; }) === idx; });
                callback(found);
                return [2 /*return*/];
        }
    });
}
export default function userRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeEvery(search, handleSearch)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map